import { ModalCartaoCovidComponent } from './modal-cartao-covid/modal-cartao-covid-component';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../components/components.module';
import { ModalDetalheAtendimentoComponent } from './modal-detalhe-atendimento/modal-detalhe-atendimento-component';
import { ModalPopoverComponent } from './modal-popover/modal-popover-component';
import { PipesModule } from 'src/app/pipe/pipes.module';
import { ModalFabComponent } from './modal-fab/modal-fab-component';
import { ModalCorVacinaComponent } from './modal-cor-vacina/modal-cor-vacina-component';
import { ModalDetalheMedicamentoComponent } from './modal-detalhe-medicamento/modal-detalhe-medicamento-component';
import { HttpLoaderFactory } from 'src/util/translateLoader';
import { ModalCarteiraVacinacaoComponent } from './modal-carteira-vacinacao/modal-carteira-vacinacao.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PrescricaoQrcodeComponent } from './prescricao-qrcode/prescricao-qrcode.component';
import { LogoutComponent } from './logout-component/logout-component';
import { BrMaskerModule } from 'br-mask';
import { CalendarioComponent } from './calendario/calendario.component';
import { ModalErrorComponent } from './modal-error/modal-vacina-error-component';
import { ModalSelecionarCertificadoComponent } from './modal-selecionar-certificado/modal-selecionar-certificado.component';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ComponentsModule,
        ReactiveFormsModule,
        PipesModule,
        PdfViewerModule,
        BrMaskerModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
    ],
    declarations: [
        ModalDetalheAtendimentoComponent,
        ModalPopoverComponent,
        ModalFabComponent,
        ModalCorVacinaComponent,
        ModalDetalheMedicamentoComponent,
        ModalCarteiraVacinacaoComponent,
        PrescricaoQrcodeComponent,
        LogoutComponent,
        ModalCartaoCovidComponent,
        CalendarioComponent,
        ModalErrorComponent,
        ModalSelecionarCertificadoComponent
    ],
    entryComponents: [
        ModalDetalheAtendimentoComponent,
        ModalPopoverComponent,
        ModalFabComponent,
        ModalCorVacinaComponent,
        ModalDetalheMedicamentoComponent,
        ModalCarteiraVacinacaoComponent,
        PrescricaoQrcodeComponent,
        LogoutComponent,
        ModalCartaoCovidComponent,
        CalendarioComponent,
        ModalErrorComponent,
        ModalSelecionarCertificadoComponent
    ],

    exports: [
        ModalDetalheAtendimentoComponent,
        ModalPopoverComponent,
        ModalCorVacinaComponent,
        CalendarioComponent,
        ModalErrorComponent,
        ModalSelecionarCertificadoComponent
    ]
})

export class ModalComponents {
}
